import { BTable, BFormInput, VBModal, VBToggle, BModal } from "bootstrap-vue";
import AddBonModal from "@@/core/components/customerClub/addBon/AddBon.vue";
export default {
  name: "BonSettings",
  components: {
    BTable,
    BFormInput,
    BModal,
    AddBonModal,
  },
  directives: {
    "b-modal": VBModal,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      disabled: false,
      url: "admin/customers_club/get_bon_values",
      updateUrl: "admin/customers_club/add_purchase_score",
      setValueUrl: "admin/customers_club/set_bon_value",
      items: [],
      fields: [
        {
          label: "شناسه",
          key: "id",
        },
        {
          label: "مقدار",
          key: "value",
        },
        {
          label: "تاریخ",
          key: "date",
        },
        {
          label: "عملیات",
          key: "actions",
        },
      ],
      editForm: {
        id: null,
        value: null,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.disabled = true;
      await this.$axios
        .get(this.url)
        .then((res) => {
          this.items = res.data.data.list;
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    afterUpdate(items) {
      this.items = items;
      this.$forceUpdate();
    },

    openEditModal(item) {
      this.editForm.id = item.id;
      this.editForm.value = item.value;
      this.$refs.editBonModal.show();
    },

    async submitEditValue(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.editForm.value) {
        this.$root.notify("مقدار را وارد کنید");
        return;
      }

      this.disabled = true;
      await this.$axios
        .put(`${this.setValueUrl}/${this.editForm.id}`, {
          value: this.editForm.value,
        })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
          const target = this.items.find((i) => i.id === this.editForm.id);
          if (target) {
            target.value = this.editForm.value;
          }
          this.$refs.editBonModal.hide();
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};